import { auth } from "@/http";
import { environmentId } from "@/utils";
import { UnauthorizedError } from "@/utils/error";

function fetchServerTime() {
  return auth.get(`config/${environmentId()}/server_clock`).catch(error => {
    if (error.response.status === 401) {
      throw new UnauthorizedError();
    } else throw new Error();
  });
}

function fetchVersions() {
  return auth.get(`config/${environmentId()}/versions`).catch(error => {
    if (error.response.status === 401) {
      throw new UnauthorizedError();
    } else throw new Error();
  });
}

export default {
  fetchServerTime,
  fetchVersions
};
